module.exports = __webpack_public_path__ + "static/media/people.13d6f7eb.svg";